(function (d) {
  const hrefs = d.querySelectorAll('a');
  const bookNowButtons = Array.from(hrefs).filter((href) => {
    if (href.innerHTML.toLowerCase().search('book now') > -1) {
      return href;
    }

    if (href.innerHTML.toLowerCase().search('schedule') > -1) {
      return href;
    }
  });
  bookNowButtons.forEach((button) => {
    button.addEventListener('click', (e) => {
      e.preventDefault();
      const se = window.ScheduleEngine;
      se.show();
      // alert('When site is live this will open a SE popup');
    });
  });
})(document);
